import React from "react";

export default function Signin() {
  return <div className="text-white font-extrabold">Comming Soon</div>;
}
